/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[iI]gnored" }]*/

import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAlarmsFn = leadId => restHelpers.withBearer.get(`${K.API_URL}/alarms/leads/${leadId}?_=${new Date().getTime()}`, {});

const getCarFn = carId => restHelpers.withBearer.get(`${K.API_URL}/cars/${carId}?_=${new Date().getTime()}`, {});

const getDtcsFn = leadId => restHelpers.withBearer.get(`${K.API_URL}/dtcs/leads/${leadId}?_=${new Date().getTime()}`, {});

const getLeadFn = carId => restHelpers.withBearer.get(`${K.API_URL}/leads/cars/${carId}?_=${new Date().getTime()}`, {});

const getLeadHistoryFn = carId => restHelpers.withBearer.get(`${K.API_URL}/leads/cars/${carId}/history?_=${new Date().getTime()}`, {});

const getMaintenancesFn = carId => restHelpers.withBearer.get(`${K.API_URL}/maintenances/cars/${carId}?_=${new Date().getTime()}`, {});

const confirmManagedMaintenancesFn = maintenanceId => restHelpers.withBearer.put(`${K.API_URL}/maintenances/${maintenanceId}/done`, { data: {} });

const getMaintenancesCarHistoryFn = (carId, page = 1, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/maintenance-histories/cars/${carId}?=${new Date().getTime()}&page=${page - 1}&size=10${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const sendNoteFn = (carId, note) => restHelpers.withBearer.post(`${K.API_URL}/notes`, { data: { note, carId } });

const getNotesHistoryFn = (carId, page = 1, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/notes/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=10${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const getDtcsHistoryFn = (carId, page = 1, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/dtc-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=10${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const getAlarmsHistoryFn = (carId, page = 1, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/alarm-histories/cars/${carId}?_=${new Date().getTime()}&page=${page - 1}&size=10${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const setShutdownFn = (carId, shutdown) => restHelpers.withBearer.put(`${K.API_URL}/cars/${carId}/shutdown/${shutdown}`, {});

const getConfigFn = carId => restHelpers.withBearer.get(`${K.API_URL}/cars/${carId}/current-configuration`, {});

const getBatteryLevelHistoryFn = carId => restHelpers.withBearer.get(`${K.API_URL}/battery-histories/cars/${carId}?_=${new Date().getTime()}`, {});

const closeLeadFn = (leadId, reason) => restHelpers.withBearer.post(`${K.API_URL}/leads/close`, { data: { id: leadId, closeOrDiscardReason: reason } });

const openLeadFn = (carId) => restHelpers.withBearer.post(`${K.API_URL}/open-lead-manually`, { data: { carId } });

const exportLeadLifeCycleFn = (leadId) => restHelpers.withBearer.get(`${K.API_URL}/leads/${leadId}/export-life-cycle?_=${new Date().getTime()}`, {});

const addMaintenanceFn = ({ carId, description, km, date }) =>
  restHelpers.withBearer.post(`${K.API_URL}/maintenances`, { data: { description, km, date, carId, type: 'general', custom: true } });

const updateMaintenanceFn = ({ maintenanceId, description, km, date }) =>
  restHelpers.withBearer.put(`${K.API_URL}/maintenances/${maintenanceId}`, { data: { description, km, date, type: 'general', custom: true } });

const deleteMaintenanceFn = (maintenanceId) => restHelpers.withBearer.delete(`${K.API_URL}/maintenances/${maintenanceId}`);

const setObdServiceFn = (carId, service) => restHelpers.withBearer.put(`${K.API_URL}/cars/${carId}/obd-service/${service}`, {});

const deleteCarFn = carId => restHelpers.withBearer.delete(`${K.API_URL}/cars/${carId}`);

const launchFullScanFn = carId => restHelpers.withBearer.post(`${K.API_URL}/cars/${carId}/launch-full-scan`, {});

const getFullScanStatusFn = carId => restHelpers.withBearer.get(`${K.API_URL}/cars/${carId}/get-full-scan-status?_=${new Date().getTime()}`, {});

export default {
  updateMaintenance: updateMaintenanceFn,
  deleteMaintenance: deleteMaintenanceFn,
  getAlarms: getAlarmsFn,
  getCar: getCarFn,
  getDtcs: getDtcsFn,
  getLead: getLeadFn,
  getLeadHistory: getLeadHistoryFn,
  getMaintenances: getMaintenancesFn,
  getMaintenancesCarHistory: getMaintenancesCarHistoryFn,
  sendNote: sendNoteFn,
  getNotesHistory: getNotesHistoryFn,
  getDtcsHistory: getDtcsHistoryFn,
  getAlarmsHistory: getAlarmsHistoryFn,
  setShutdown: setShutdownFn,
  getConfig: getConfigFn,
  getBatteryLevelHistory: getBatteryLevelHistoryFn,
  confirmManagedMaintenances: confirmManagedMaintenancesFn,
  closeLead: closeLeadFn,
  openLead: openLeadFn,
  exportLeadLifeCycle: exportLeadLifeCycleFn,
  addMaintenance: addMaintenanceFn,
  setObdService: setObdServiceFn,
  deleteCar: deleteCarFn,
  launchFullScan: launchFullScanFn,
  getFullScanStatus: getFullScanStatusFn,
};
